import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import './StripeCheckoutForm.css';

function StripeCheckoutForm({ clientSecret, orderData, onSuccess, onError }) {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);
    setMessage('');

    try {
      // Confirm the payment
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/order-confirmation`,
        },
        redirect: 'if_required',
      });

      if (error) {
        setMessage(error.message);
        setIsProcessing(false);
        if (onError) onError(error);
        return;
      }

      if (paymentIntent && paymentIntent.status === 'succeeded') {
        // Payment successful, confirm with backend
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/payment/confirm-payment`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            paymentIntentId: paymentIntent.id,
            ...orderData,
          }),
        });

        const result = await response.json();

        if (response.ok) {
          if (onSuccess) onSuccess(result);
        } else {
          throw new Error(result.error || 'Failed to create order');
        }
      }

      setIsProcessing(false);
    } catch (err) {
      setMessage(err.message);
      setIsProcessing(false);
      if (onError) onError(err);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="stripe-checkout-form">
      <PaymentElement />

      {message && <div className="payment-message error">{message}</div>}

      <button
        type="submit"
        disabled={!stripe || isProcessing}
        className="btn btn-primary btn-block payment-submit-button"
      >
        {isProcessing ? 'Processing...' : 'Pay Now'}
      </button>
    </form>
  );
}

export default StripeCheckoutForm;
